var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunicationAbcRadioTower = function SvgCommunicationAbcRadioTower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#communication-abc-radio-tower_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.089,
    r: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "m10.872 8.487 2.651 1.943-.247-.573-2.404-1.77zM8.964 20.422h.742l1.166-12.335v-.412h-.646z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "m10.552 10.945 3.197 2.307-.086-.556L10.6 10.48z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "M15.062 20.422h-.742L13.154 8.087v-.412h.646z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "m10.333 13.577 3.775 2.846-.078-.637-3.697-2.756z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M10.723 5.455h2.553v2.6h-2.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "m10.014 16.824 4.35 3.169-.074-.605-4.188-3.066zM13.24 8.487l-2.651 1.943.246-.573 2.404-1.77zM13.465 10.945l-3.197 2.307.087-.556 3.062-2.215z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "m13.825 13.577-3.776 2.846.078-.637 3.698-2.756zM14.08 16.824l-4.35 3.169.074-.605 4.188-3.066z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M14.128 8.879a2.158 2.158 0 0 0 1.702-2.124 2.158 2.158 0 0 0-1.702-2.123 2.1 2.1 0 0 1 .425-.043c1.175 0 2.128.97 2.128 2.166 0 1.197-.953 2.167-2.128 2.167a2.1 2.1 0 0 1-.425-.043"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M16.113 8.879a2.158 2.158 0 0 0 1.703-2.124c0-1.048-.731-1.922-1.703-2.123a2.1 2.1 0 0 1 .426-.043c1.175 0 2.128.97 2.128 2.166 0 1.197-.953 2.167-2.128 2.167a2.1 2.1 0 0 1-.426-.043M7.886 8.879a2.158 2.158 0 0 1-1.702-2.124c0-1.048.731-1.922 1.702-2.123a2.1 2.1 0 0 0-.425-.043c-1.175 0-2.128.97-2.128 2.166 0 1.197.953 2.167 2.128 2.167a2.1 2.1 0 0 0 .425-.043"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M9.872 8.879A2.158 2.158 0 0 1 8.17 6.755c0-1.048.731-1.922 1.702-2.123a2.1 2.1 0 0 0-.425-.043c-1.175 0-2.128.97-2.128 2.166 0 1.197.953 2.167 2.128 2.167a2.1 2.1 0 0 0 .425-.043"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "communication-abc-radio-tower_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 2.089h20v20H2z"
  })))));
};
export default SvgCommunicationAbcRadioTower;